/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

import { IGetCredentialsListProps } from "./components";

const is = require("is_js");

const SERVICE_NAME = "CredentialListPageService";
const log: any = LoggerModule.getInstance();

export class CredentialListPageService {
  private static instance: CredentialListPageService;
  private vapp: VApplication;
  private criteria:any;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): CredentialListPageService {
    if (!CredentialListPageService.instance) {
      CredentialListPageService.instance = new CredentialListPageService(props);
    }
    return CredentialListPageService.instance;
  }

  private setCriteria(data:any){
    this.criteria = data;
  }

  public resetCriteria(){
    this.criteria= null
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();


    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getPageContent(args: IGetCredentialsListProps) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    if(args?.criteria){
      this.setCriteria(args?.criteria);
    }

    //Settings Props
    compProps = await agent.getSettingsProps(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //UserLists Props
    compProps = await agent.getAppCardListProps({...args, criteria:{...this.criteria, ...args?.criteria}});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }
}
